import React from 'react'
import PropTypes from 'prop-types'

const DiscountLabel = ({ discount }) => discount > 0 ? (
  <span className='pos-absolute r-1 t-1 card-flag bg-success color-brand-5 radius txt-body-sm txt-font-body-bold mt-1'>
    -{discount}%
  </span>
) : null

DiscountLabel.propTypes = {
  discount: PropTypes.number
}

DiscountLabel.defaultProps = {
  discount: 0
}

export default DiscountLabel



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/DiscountLabel/DiscountLabel.js